import { ETransactionType } from "@frameworks/shared-library/components/OrderBookSideBar/OrderBookSidebarConstants";
var EDisplayTransactionType;
(function (EDisplayTransactionType) {
    EDisplayTransactionType["AP"] = "Add. Purchase";
    EDisplayTransactionType["FP"] = "Fresh Purchase";
    EDisplayTransactionType["SIP"] = "XSIP";
})(EDisplayTransactionType || (EDisplayTransactionType = {}));
var EDeliveryMode;
(function (EDeliveryMode) {
    EDeliveryMode["D"] = "Demat";
    EDeliveryMode["P"] = "Physical";
})(EDeliveryMode || (EDeliveryMode = {}));
var mfOrderbookDetailsMapper = function (response) {
    var _a, _b, _c;
    var order = [];
    var tranSummaryList = [];
    var clientCodeList = [];
    if (((_a = response === null || response === void 0 ? void 0 : response.order) === null || _a === void 0 ? void 0 : _a.length) > 0) {
        order = response.order.map(function (item) {
            var _a, _b, _c, _d;
            return {
                trxId: item === null || item === void 0 ? void 0 : item.trxId,
                displayTransactionId: item === null || item === void 0 ? void 0 : item.dpTrxId,
                vendorTrxId: item === null || item === void 0 ? void 0 : item.vendorTrxId,
                exchangeRefNum: item === null || item === void 0 ? void 0 : item.exchangeRefNum,
                clientName: item === null || item === void 0 ? void 0 : item.clientName,
                clientCode: item === null || item === void 0 ? void 0 : item.clientCode,
                clientTier: item === null || item === void 0 ? void 0 : item.clientTier,
                ucc: item === null || item === void 0 ? void 0 : item.ucc,
                investmentType: item === null || item === void 0 ? void 0 : item.deliveryMode,
                totalNoOfInstallments: item === null || item === void 0 ? void 0 : item.numberOfInstallment,
                installmentNumber: item === null || item === void 0 ? void 0 : item.installmentNumber,
                scheme: item === null || item === void 0 ? void 0 : item.scheme,
                toScheme: item === null || item === void 0 ? void 0 : item.switchTo,
                trxType: item === null || item === void 0 ? void 0 : item.trxType,
                trxTime: item === null || item === void 0 ? void 0 : item.trxTime,
                displayTransactionTime: item === null || item === void 0 ? void 0 : item.dpTrxTime,
                amount: item === null || item === void 0 ? void 0 : item.amount,
                quantity: item === null || item === void 0 ? void 0 : item.quantity,
                frequency: item === null || item === void 0 ? void 0 : item.frequency,
                firstInstallmentDate: item === null || item === void 0 ? void 0 : item.firstInstallmentDate,
                mandateId: item === null || item === void 0 ? void 0 : item.mandateId,
                mandateType: item === null || item === void 0 ? void 0 : item.mandateType,
                displayMandateType: item === null || item === void 0 ? void 0 : item.dpMandateType,
                bankName: item === null || item === void 0 ? void 0 : item.bankName,
                accountNumber: item === null || item === void 0 ? void 0 : item.accountNumber,
                accNumLastDigit: item === null || item === void 0 ? void 0 : item.accNumLastDigit,
                totalInstallmentsCompleted: item === null || item === void 0 ? void 0 : item.totalInstallmentsPaid,
                totalInstallmentAmtPaid: item === null || item === void 0 ? void 0 : item.totalInstallmentAmount,
                startDay: item === null || item === void 0 ? void 0 : item.startDay,
                displayBankName: item === null || item === void 0 ? void 0 : item.dpBank,
                endDate: item === null || item === void 0 ? void 0 : item.endDate,
                txnStatus: item === null || item === void 0 ? void 0 : item.txnStatus,
                displayStatus: (_a = item === null || item === void 0 ? void 0 : item.finalStatus) === null || _a === void 0 ? void 0 : _a.toLowerCase(),
                paymentStatus: item === null || item === void 0 ? void 0 : item.paymentStatus,
                transactionNav: item === null || item === void 0 ? void 0 : item.transNav,
                displayTransactionType: (item === null || item === void 0 ? void 0 : item.trxType) === EDisplayTransactionType.AP ||
                    (item === null || item === void 0 ? void 0 : item.trxType) === EDisplayTransactionType.FP
                    ? ETransactionType.LUMPSUM
                    : (item === null || item === void 0 ? void 0 : item.trxType) === EDisplayTransactionType.SIP
                        ? ETransactionType.SIP
                        : item === null || item === void 0 ? void 0 : item.trxType,
                nextInstallmentDate: item === null || item === void 0 ? void 0 : item.nextInstallmentDate,
                groupCode: item === null || item === void 0 ? void 0 : item.groupCode,
                isinName: (_b = item === null || item === void 0 ? void 0 : item.scheme) === null || _b === void 0 ? void 0 : _b.isinName,
                swpFlag: item === null || item === void 0 ? void 0 : item.swpFlag,
                stpFlag: item === null || item === void 0 ? void 0 : item.stpFlag,
                pauseFlag: item === null || item === void 0 ? void 0 : item.pauseFlag,
                redFlag: item === null || item === void 0 ? void 0 : item.redFlag,
                switchFlag: item === null || item === void 0 ? void 0 : item.switchFlag,
                pauseMaxInstallment: item === null || item === void 0 ? void 0 : item.pauseMaxInstallment,
                pauseCount: item === null || item === void 0 ? void 0 : item.pauseCount,
                firstOrderToday: (item === null || item === void 0 ? void 0 : item.firstOrderToday) === "t",
                registrationNumber: item === null || item === void 0 ? void 0 : item.registrationNumber,
                schemeCode: (_c = item === null || item === void 0 ? void 0 : item.scheme) === null || _c === void 0 ? void 0 : _c.schemeCode,
                ISIN: (_d = item === null || item === void 0 ? void 0 : item.scheme) === null || _d === void 0 ? void 0 : _d.isin,
                dataSource: item === null || item === void 0 ? void 0 : item.dataSource,
                clientBankName: item === null || item === void 0 ? void 0 : item.clientBankName,
                clientBankAcNum: item === null || item === void 0 ? void 0 : item.clientBankAcNum,
                paymentMethod: item === null || item === void 0 ? void 0 : item.paymentMethod,
                invActionCode: item === null || item === void 0 ? void 0 : item.invActionCode,
                displayCreatedTime: item === null || item === void 0 ? void 0 : item.dpCreatedTime,
                tableDisplayCreatedTime: item === null || item === void 0 ? void 0 : item.mainDpCreatedTime,
                orderRemarks: item === null || item === void 0 ? void 0 : item.orderRemarks,
                pan: item === null || item === void 0 ? void 0 : item.pan,
                typeOfOrder: item.typeOfOrder,
                displayStartDay: item === null || item === void 0 ? void 0 : item.dpStartDay,
                dpFrequency: item === null || item === void 0 ? void 0 : item.dpFrequency,
            };
        });
    }
    if ((_b = response === null || response === void 0 ? void 0 : response.tranSummaryList) === null || _b === void 0 ? void 0 : _b.length) {
        tranSummaryList = response === null || response === void 0 ? void 0 : response.tranSummaryList;
    }
    if ((_c = response === null || response === void 0 ? void 0 : response.clientCodeList) === null || _c === void 0 ? void 0 : _c.length) {
        clientCodeList = response === null || response === void 0 ? void 0 : response.clientCodeList;
    }
    return {
        order: order,
        tranSummaryList: tranSummaryList,
        clientCodeList: clientCodeList,
    };
};
export default mfOrderbookDetailsMapper;
